import React, { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';
import rapidapiBadgeLight from '../../../../assets/images/rapidapi-badge-light.png';
import { useAccount } from '../../../../hooks/useAccount';
import SettingsPageLayout from '../../../../layouts/settings/settingsPageLayout';
import { ApiApp } from '../../../../services/models/api-app';
import { AppType } from '../../../../services/models/app-type';

const RapidapiIntegrationPage: FunctionComponent = () => {
  const { account } = useAccount();
  const apiApps: ApiApp[] = account?.apiApps || [];
  const rapidapiApp = apiApps.find(x => x.type === AppType.RapidApi);

  if (!rapidapiApp) {
    return <Redirect to="/dashboard/settings/integrations" />;
  }

  return (
    <SettingsPageLayout title="RapidAPI Integration | Newslit">
      <div className="mt-10 divide-y divide-gray-200">
        <div className="space-y-1">
          <h3 className="text-lg leading-6 font-bold text-gray-900">RapidAPI Integration</h3>
          <p className="max-w-2xl text-sm text-gray-500 m-0">
            Integrate your News Briefs into your application or website through a single API
          </p>
        </div>

        <div className="mt-6">
          <dl className="divide-y divide-gray-200">
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-medium text-gray-500">API Key</dt>
              <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <span className="grow">
                  <code>{rapidapiApp.apiKey}</code>
                </span>
              </dd>
            </div>
          </dl>
          <div className="text-gray-600 font-normal mt-4">
            <a href="https://rapidapi.com/user/newslit" target="_blank" rel="noopener noreferrer">
              <img src={rapidapiBadgeLight} width="215" alt="Connect on RapidAPI" />
            </a>
          </div>
        </div>
      </div>
    </SettingsPageLayout>
  );
};

export default RapidapiIntegrationPage;
